import React from 'react';
import Chart from "react-apexcharts";
import { chartTimeFormat } from "../../../Js/TimeAndDate";
import { Margin } from '@mui/icons-material';

const StackBarChart = (props) => {

  let trainerReportData = props.stackBarData;
  let labelData = [];
  let courseData = [];
  let taskData = [];
  let assiData = [];
  let evalData = [];

  for (let i = 0; i < trainerReportData.length; i++) {
    labelData.push(props.fetchTrainer(trainerReportData[i].actor));
    courseData.push(chartTimeFormat(parseInt(trainerReportData[i].courseTime)).toFixed(0));
    taskData.push(chartTimeFormat(parseInt(trainerReportData[i].taskTime)).toFixed(0));
    assiData.push(chartTimeFormat(parseInt(trainerReportData[i].assiTime)).toFixed(0));
    evalData.push(chartTimeFormat(parseInt(trainerReportData[i].evalTime)).toFixed(0));
  }

  let chartSeries = [];
  let xs = {
    'xaxis': {
      'categories': labelData,
    }
  };

  let obj = {
    'name': 'Presentation',
    'data': courseData
  };
  let obj1 = {
    'name': 'Task',
    'data': taskData
  };
  let obj2 = {
    'name': 'Assignment',
    'data': assiData
  };
  let obj3 = {
    'name': 'Evaluation',
    'data': evalData
  };

  let xs2 = {
    'stacked': true,
    'stackType': '100%',
    'toolbar': {
      'show': true,
      'tools': {
        'download': true
      },
      'export': {
        'csv': {
          headerCategory: 'Trainer Name',
        },
        'png': {
          'filename': 'TrainerReport',
        }
      }
    }
  }
  xs.chart = xs2;
  xs.plotOptions = {
    bar: {
      borderRadius: 0,
      columnWidth: '25%',
      horizontal: (props.isHorizontal) ? props.isHorizontal : false,
    }
  };
  xs.dataLabels = {
    enabled: true,
    formatter: function (value, { seriesIndex, dataPointIndex, w }) {
      if (w.config.series[seriesIndex].name == 'Presentation') {
        return w.config.series[seriesIndex]['data'][dataPointIndex]+' m';
      } else {
        return '.';
      }
    },
    offsetY: 6,
    style: {
      fontSize: '1vw',
      colors: ["#513058ff"]
    }
  };

  let ys = {
    'title': { 'text': '' },
    labels: {
      show: true,
      style: {
        fontSize: '1vw',
        fontWeight: 900,
      }
    }
  };
  xs.yaxis = ys;
  xs.tooltip = {
    enabled: true,
    y: {
      formatter: undefined,
      title: {
        formatter: (seriesName) => seriesName,
      },
    },
  }

  let chartOptions = xs;
  // console.log(chartOptions);
  chartSeries.push(obj, obj1, obj2, obj3);

  return (
    <Chart
      options={chartOptions}
      series={chartSeries}
      type="bar"
      width={(props.chartWidth) ? props.chartWidth : 380}
      height={(props.chartHeight) ? props.chartHeight : 'auto'}
    />
  );
};
export default StackBarChart;
